/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class STScheduleGridApi {
  async FetchCalendar(viewGU : string, objectID : string) : Promise<st.CalendarInfo> {
    return await componentApi.call('st', 'st-schedule-grid', 'STScheduleGridApi', 'FetchCalendar', {
      viewGU,
      objectID,
    });
  }
  async FetchAppointments(viewGU : string, objectID : string, identity : string) : Promise<st.AppointmentData> {
    return await componentApi.call('st', 'st-schedule-grid', 'STScheduleGridApi', 'FetchAppointments', {
      viewGU,
      objectID,
      identity,
    });
  }
}
export default new STScheduleGridApi()
